import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Cell, ColumnHead, Row, TableContainer, TableHead } from "./Table.styles";
var makeTableRowWithColumns = function(columns) {
    return function(row) {
        return /*#__PURE__*/ _jsx(Row, {
            children: columns.map(function(param) {
                var key = param.key, CellContent = param.component;
                // eslint-disable-next-line react/destructuring-assignment
                var data = row[key];
                if (CellContent) {
                    return /*#__PURE__*/ _jsx(Cell, {
                        children: /*#__PURE__*/ _jsx(CellContent, {
                            data: data
                        })
                    }, String(key));
                }
                return /*#__PURE__*/ _jsx(Cell, {
                    children: "".concat(data)
                }, String(key));
            })
        });
    };
};
var Table = function(param) {
    var columns = param.columns, id = param.id, rows = param.rows;
    var SupplierRow = makeTableRowWithColumns(columns);
    return /*#__PURE__*/ _jsxs(TableContainer, {
        id: id,
        children: [
            /*#__PURE__*/ _jsx(TableHead, {
                children: /*#__PURE__*/ _jsx(Row, {
                    children: columns.map(function(param) {
                        var columnHeader = param.columnHeader;
                        return /*#__PURE__*/ _jsx(ColumnHead, {
                            children: columnHeader
                        }, columnHeader);
                    })
                })
            }),
            /*#__PURE__*/ _jsx("tbody", {
                children: rows.map(function(row, index) {
                    return /*#__PURE__*/ _jsx(SupplierRow, _object_spread({}, row), "row-".concat(String(index)));
                })
            })
        ]
    });
};
export { Table };
